import { ContextConsumer } from "@lit/context";
import type { LitElement } from "lit";
import { tvrnServiceCtx } from "#app/context.ts";
import type { TvrnService } from "#app/tvrn-service.ts";

type Constructor<T = unknown> = new (
  // biome-ignore lint/suspicious/noExplicitAny: using `unknown` triggers TS2545, see <https://github.com/microsoft/TypeScript/issues/37142>
  ...args: any[]
) => T;

export declare class ApiConsumerInterface extends LitElement {
  get tvrnService(): TvrnService;
}

export const ApiConsumer = <T extends Constructor<LitElement>>(el: T) =>
  class extends el {
    #apiConsumer = new ContextConsumer(this, { context: tvrnServiceCtx });

    get tvrnService(): TvrnService {
      if (this.#apiConsumer.value === undefined) {
        throw new Error("api client is not available");
      }

      return this.#apiConsumer.value;
    }
  } as Constructor<ApiConsumerInterface> & T;
